const themeColor = {
  black: {
    baseBgColor: 'rgba(37, 42, 68, 1)',
    titleBgColor1: 'rgba(16, 20, 36, 1)',
    contentBgColor1: 'rgba(23, 27, 43, 1)',
    contentBgColor2: 'rgba(19, 22, 37, 1)',
    contentBgColor3: 'rgba(16, 20, 36, 1)',
    hoverBgColor: 'rgba(15, 18, 31, 1)',
    hoverBgColorOpacity: 'rgba(15, 18, 31, 0.5)',
    sliderBgColor: 'rgba(32, 38, 60, 1)',
    inputBgColor: 'rgba(11, 15, 29, 1)',
    inputBorder: 'rgba(72, 75, 91, 1)',
    textColor1: 'rgba(255, 255, 255, 1)', // 大标题
    textColor2: 'rgba(90, 95, 133, 1)', // 小标题
    textColor3: 'rgba(176, 184, 219, 1)', // 普通内容字体
    textColor4: 'rgba(210, 215, 236, 1)', // K线组件顶部价格字体
    textColor5: 'rgba(125, 132, 161, 1)', // K线组件顶部指标文字字体
    textColor6: 'rgba(138, 145, 171, 1)', // 交易中心可用余额文字
    textColor7: 'rgba(83, 96, 120, 1)', // 交易中心交易额文字
    textColor8: 'rgba(155, 159, 174, 1)' // 交易中心交易额数字文字
  },
  white: {
    baseBgColor: 'rgba(224, 231, 243, 1)',
    titleBgColor1: 'rgba(242, 246, 250, 1)',
    contentBgColor1: 'rgba(255, 255, 255, 1)',
    contentBgColor2: 'rgba(255, 255, 255, 1)',
    contentBgColor3: 'rgba(255, 255, 255, 1)',
    hoverBgColor: 'rgba(235, 241, 245, 1)',
    hoverBgColorOpacity: 'rgba(235, 241, 245, 0.5)',
    sliderBgColor: 'rgba(224, 231, 243, 1)',
    inputBgColor: 'rgba(242, 246, 252, 1)',
    inputBorder: 'rgba(153, 153, 153, 1)',
    textColor1: 'rgba(51, 51, 51, 1)',
    textColor2: 'rgba(153, 153, 153, 1)',
    textColor3: 'rgba(51, 51, 51, 1)',
    textColor4: 'rgba(51, 51, 51, 1)',
    textColor5: 'rgba(153, 153, 153, 1)',
    textColor6: 'rgba(153, 153, 153, 1)',
    textColor7: 'rgba(153, 153, 153, 1)',
    textColor8: 'rgba(51, 51, 51, 1)'
  }
}

export default themeColor
